'use es6';

const ID_MATCHER = /((widget|module)_*)(\d*)/;
export default (id => {
  if (ID_MATCHER.test(id)) {
    return Number(ID_MATCHER.exec(id)[3]);
  }
  return Number(id);
});